import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Street from './street';
import StreetTwo from './street-two';
import City from './city';
import State from './state';
import Zip from './zip';

const Row = styled.div`
  padding-bottom: 2rem;
  position: relative;
  width: 100%;
`;

const SingleLineWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
  align-items: normal;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    justify-content: space-between;
    align-items: flex-end;
    position: relative;
    flex-direction: row;
  }
`;

const SingleLineWrapperRowLeft = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    width: 20rem;
  }
`;

const SingleLineWrapperRowMiddle = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    width: 10rem;
  }
`;

const SingleLineWrapperRowRight = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    width: 8rem;
  }
`;

const ManualAddressEntry = props => {
  const { error, value, type, hideStreet2 } = props;

  return (
    <div>
      <Row>
        <Street
          data-cv-test={`${type}AddressStreetLineOne`}
          {...props}
          error={error[`${type}Street`]}
          value={value[`${type}Street`]}
          name={`${type}Street`}
        />
      </Row>

      {!hideStreet2 && (
        <Row>
          <StreetTwo
            data-cv-test={`${type}AddressStreetLineTwo`}
            {...props}
            error={error[`${type}Street2`]}
            value={value[`${type}Street2`]}
            name={`${type}Street2`}
          />
        </Row>
      )}

      <SingleLineWrapper>
        <SingleLineWrapperRowLeft>
          <City
            data-cv-test={`${type}AddressCity`}
            {...props}
            error={error[`${type}City`]}
            value={value[`${type}City`]}
            name={`${type}City`}
          />
        </SingleLineWrapperRowLeft>

        <SingleLineWrapperRowMiddle>
          <State
            data-cv-test={`${type}AddressState`}
            {...props}
            error={error[`${type}State`]}
            value={value[`${type}State`] || 'default'}
            name={`${type}State`}
          />
        </SingleLineWrapperRowMiddle>

        <SingleLineWrapperRowRight>
          <Zip
            data-cv-test={`${type}AddressZip`}
            {...props}
            error={error[`${type}Zip`]}
            value={value[`${type}Zip`]}
            name={`${type}Zip`}
          />
        </SingleLineWrapperRowRight>
      </SingleLineWrapper>
    </div>
  );
};

ManualAddressEntry.propTypes = {
  type: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  hideStreet2: PropTypes.bool
};

ManualAddressEntry.defaultProps = {
  type: 'home',
  error: false,
  value: null,
  hideStreet2: false
};

export default ManualAddressEntry;
